import { useQuery, QueryHookOptions, QueryResult } from '@apollo/client'

import { UserBaseDataQuery } from 'gql'
import { USER_BASE_DATA } from 'gql/user/queries'

type UseUserResult = [UserBaseDataQuery['currentUser'], Partial<QueryResult>]

const useUser = (options?: QueryHookOptions): UseUserResult => {
  const { data: user, ...rest } = useQuery<UserBaseDataQuery>(USER_BASE_DATA, options)

  return [user?.currentUser, rest]
}

export default useUser
